import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type AISeoGenerateRequest as SchemaAISeoGenerateRequest } from '../schemas/AISeoGenerateRequest';
import { type GenerateAISeoShortResponse as SchemaGenerateAISeoShortResponse } from '../schemas/GenerateAISeoShortResponse';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Pages
 */
export const GenerateAISeoForOtherPagesContentType = 'application/json' as const;
export type GenerateAISeoForOtherPagesRequest = SchemaAISeoGenerateRequest;
export type GenerateAISeoForOtherPagesResponses = LinkCommonErrorResponses & {
    /**
     * @description Успешная генерация сео текстов
     */
    '200': {
        'application/json': SchemaGenerateAISeoShortResponse;
    };
};
export type GenerateAISeoForOtherPagesResponseSuccess = GenerateAISeoForOtherPagesResponses['200']['application/json'];
export type GenerateAISeoForOtherPagesSearchParams = undefined;
export type GenerateAISeoForOtherPagesPathParameters = undefined;
export const GenerateAISeoForOtherPagesUrl = '/pages/other/seo/ai/generate' as const;
export const GenerateAISeoForOtherPagesMethod = 'POST' as const;
export const getGenerateAISeoForOtherPagesUrl = (_params?: GenerateAISeoForOtherPagesPathParameters) =>
    GenerateAISeoForOtherPagesUrl;
